module.exports = __webpack_public_path__ + "static/media/henglaytitle.12ed6494.png";